/* eslint-disable jsx-a11y/anchor-is-valid */
import { baseUrlCites as baseUrl, baseUrlWP, localUrl } from "@ora/recursos/src/helpers/Url";
import axios from "axios";
// import "css/reportes/scrollbar.css";
import typeahead from 'corejs-typeahead';
import "css/frontend/ficha-especie.scss";
import "css/reportes/fichaespecie.css";
import dt from 'datatables.net';
import { checkObjects } from "helpers/Utils";
import Highcharts from 'highcharts/highmaps';
import defaultImg from 'img/default.png';
import $ from 'jquery';
import CHighcharts from "layouts/mainsection/components/CHighcharts";
import CMapHighcharts from "layouts/mainsection/components/CMapHighcharts";
import qs from 'query-string';
import React, { Component, createRef } from "react";
import {
  Card
} from 'react-bulma-components';
import { Chart } from "react-google-charts";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getLanguage, SetLanguage, set_datapage } from 'redux/actions/DataPageAction';




window.Highcharts = Highcharts
require('@highcharts/map-collection/custom/world');
require('@highcharts/map-collection/custom/south-america');
$.DataTable = dt
$.typeahead = typeahead
// ChartJS.register(...registerables);
const SpinLoader = <div><div className="ld ld-spinner  ld-spin"></div></div>
const SpinLoaderStyle = <div style={{
  textAlign: 'center', 
  height: '7em',
  position: 'relative',
  top: '2.5em'
}}><div className="ld ld-spinner  ld-spin"></div></div>


const hiddenBtnGenerar = {
  height: '0px',
  overflow: 'hidden',
};
const ImageDistribution = class extends Component {
  state = {
    srcX: defaultImg,
    href: '#',
    title: '',
    // search: {
    //   pli_int_id: 0
    // }
  }
  requestInit = null
  requestInitTypeHead = null
  constructor (props) {
    super(props)
    this.requestInit = axios.CancelToken.source()
    
  }
  componentDidMount () {
    $("#imagedistribution")
    // .on('load', function() { console.log("image loaded correctly"); })
    .on('error', () => { 
      let src = defaultImg, link = '#', title = ''
      this.setState({
          srcX: src,
          href: link,
          title: title
      })
      // console.log("error loading image"); 
      axios.get(`https://www.googleapis.com/customsearch/v1?key=${process.env.REACT_APP_APIKEYSEARCH}&cx=${process.env.REACT_APP_ENGINEKEY}&searchType=image&q=${this.props.alt + ' image'}`, {cancelToken: this.requestInit.token}).then(res => {
        
        if (res.data.items.length > 0) {
          let list = res.data.items.filter(item => item.link !== undefined && item.image !== undefined && item.image.contextLink !== undefined)
          if (list.length > 0) {
            try {

              src = list[0].link
              link = list[0].image.contextLink
              title = list[0].title
              
            } catch (err) {
             src = defaultImg
             link = '#'
            }
          }
        }
        this.setState({
            srcX: src,
            href: link,

            title: title
        })
      })
      
    })
    this.setState({
      srcX: this.props.src
    })
    
    // this.initTypeahead()
  }
  render () {
    return   <div className="column">
    <div className="about_img animation animated fadeInUp" data-animation="fadeInUp" data-animation-delay="0.02s" >
    <figure className="image">
      <a href={ this.state.href } target="_blank" rel="noreferrer">
        <img id="imagedistribution" alt={ this.props.alt } src={ this.state.srcX } /> 
      </a>
      </figure>
      </div>
      <h3 className="has-text-centered is-size-7"><em><a href={ this.state.href }>Fuente: Images - Google - {this.state.title} </a></em></h3>
  </div>
  }
}
class DashboardCites extends Component {
    filter = {
        buscar: '' 
    }
    selects = {
      cites: [],
      especies: []
    }
    currentSelect = {
      cite: '',
      especie: 0,
      dataEspecie: null
    }
    datatable=null

    refSelectEspecies = null
    refSelectCites = null
    refSelectReyno = null
    refSelectGrupos = null
    refSelectYear = null
    refSelectPais = null
    refSelectPaisYear = null

    BGMapChart = '#81d4fa'

    chartMapGlobal = null

    paramsURL = {}
    requestInitTypeHead = []
    constructor (props) {
        super(props)
        this.requestInit = axios.CancelToken.source()
        let objFinal = {}
      
  
        this.paramsURL =qs.parse(this.props.location.search)
        
         
        objFinal = {
            panels: {
              description: true,
              exportaciones: true,
              importaciones: true,
              solo_permisos: true,
              solo_decomisos: true,
              yearexportaciones: true,
              yearimportaciones: true,
              yearpermisos: true,
              yeardecomisos: true,
            },
            filtersTabOne: {
              reyno: '-1',
              grupo: -1,
            },
            chartList: {
              aperture: false,
              showGenerar: true,
              A: null,
              B: null,
              BB: null,
              C: null,
              D: null,
              DD: null,
              E: null,
              F: null,
              G: null,
              H: null,
            },
            chartListYear: {
              aperture: false,
              showGenerar: true,
              AA:null,
              A: null,
              B: null,
              IA: null,
              IB: null,
              IC: null,
              YPA: null,
              YPB: null,
              YDA: null,
              YDB: null
            },
            chartListPais: {
              aperture: false,
              showGenerar: true,
              A: null,
              B: null,
          
            },
            initTabOne: false,
            currentEspecieTab3: '',
            especiesMasExportadasTab3: [],
            mapsChartDistribution: null,
            mapsChartPais: null,
            currentTab: 1,
            listEspecies: [],
            loadInformationTab1: false,
            currentDataEspeciePaises: [],
            currentDataEspecie: {
              pli_txt_scientificname: '',
              imageDefault: '',
              pli_txt_commonnames_f: '',
              pli_txt_cite_f: '',
              pli_txt_uicn: '',
              pli_txt_taxonid: '',


              pli_txt_kingdom: '',
              pli_txt_phylum: '',
              pli_txt_class: '',
              pli_txt_order: '',
              pli_txt_family: '',
              pli_txt_genus: ''
            },
            lista: false,
            cites: false,
            citesSelect: [],
            especiesSelect: [],
            iucn: false,
            paises: false,
            recursos: false,
            tiporecurso:false,
            typeahead: {
              pli_int_id: 0
            },
            search:{txt_ncc:"",sel_year: "", sel_iucn: "",sel_recurso: "",sel_tiporecurso: "",sel_pais: ""} ,
            filter : {},
            regpag:process.env.REG_PAG,
            dataLoadingStatus: 'ready',
            chartData: [],
            total:0,
            datosCargados: false,
            
          };
          if (this.paramsURL.t !== undefined && (this.paramsURL.t >= 1 && this.paramsURL.t <=3)) {
            objFinal.currentTab = +this.paramsURL.t
          }
        this.state = objFinal
                 
          this.refSelectEspecies = createRef()
          this.refSelectCites = createRef()
          this.refSelectReyno = createRef()
          this.refSelectGrupos = createRef()
          this.refSelectYear = createRef()
          this.refSelectPais = createRef()
          this.refSelectPaisYear = createRef()

        console.log(this.paramsURL)
          this.organizeUrlsGET(this.paramsURL)
       
    }
    organizeUrlsGET = (params) => {
    
      
    }
    initTypeahead =  () => {
      // this.requestInitTypeHead.push(axios.CancelToken.source())
      console.log('initTypeahead')
        const fnTargetText = (e, data) => {
            
            this.setState({          
              typeahead: {
                    ...this.state.typeahead,
                    pli_int_id: data.pli_int_id
                }
            })

            
        }
        let countSearchs = 0
        $('#search_especies').typeahead({
          highlight: true,
          hint: false,
          minLength: 1
          }, {
          async: true,
          name: 'search-decomisos',
          display: function display(d) {
              return `${d.pli_txt_scientificname}`
          },
          templates: {
             
            pending: () => {
              return `<div class=" pl-2">${this.props.language('buscando', 'Buscando')}...</div>`
            },
            empty: () => {
              return `<div class=" pl-2">${this.props.language('sin resultados', 'Sin resultados')}</div>`
            },
              suggestion: h => {
                  // if (h.asPlaceholder !== undefined) {
                  //     return `<div>Solo buscar <b>"${h.text}"</b></div>`
                  // } else 
                      return `<div>${h.pli_txt_scientificname} <i>(${h.pli_txt_commonnames_f})</i></div>`
              }
          },
          source: (q, cb, asy) => {
              // let result = []
              if (this.requestInitTypeHead[countSearchs - 1] !== undefined) {
                this.requestInitTypeHead[countSearchs - 1].cancel()
                
              }
              this.requestInitTypeHead.push(axios.CancelToken.source())
              if (q.trim() !== '') {
              // var no_buscar = _this.cilindros.map(function (v) {
              //     return v.id;
              // });
              // console.log(no_buscar);
              // axios.get(BASE_URL + '/api/cilindro?m=all&q=' + q, {params: {cilindros: no_buscar}}).then(res => {
              
              // cb([{count: 0, asPlaceholder: true, text: q.trim()}]);
              axios.get(baseUrl('cites/dashboard/getespeciesth'), {
                  params: { q: q.trim() },
                  cancelToken: this.requestInitTypeHead[countSearchs++].token
              }).then(function (res) {
                  // console.log(res.data)
                  // return res.data
                  // res.data.unshift({count: 0, text: `Solo buscar "${q.trim()}"` })
                  asy(res.data.data);
                  // return res.data
              });

              // let regex = new RegExp(q, 'i');
              // cb(_this.listaBancos.filter(v => {
              //   return regex.test(v.banco_name)
              // }))
              }
          }
          })
          .bind('typeahead:select', fnTargetText)
          .bind('typeahead:autocomplete', fnTargetText)
          .bind('typeahead:asyncrequest', function(e, x) {
            
          })
          .bind('typeahead:asynccancel typeahead:asyncreceive', function(e, x) {
            
          });
          ;
    }

    setDataPage = () => {
      
       this.props.set_datapage({ titulo: `Dashboard Especies  CITES`,
          isbackend:false,
          be_itemselect:"exportaciones_cites",//clave de item del menu backend que se debe activar 
          breadcrumb:[
              {name:"Inicio",url:localUrl("/")},
              {name:"Reportes",url:"#"},
              {name:"Dashboard especies CITES",url:"#",active:true},
          ]});
        
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
      
      if (100 === +this.props.countDataPage) {
        this.setDataPage()
      
      }

    }
    componentDidMount() {
 
        this.setDataPage()

        var params=qs.parse(this.props.location.search)
        

        var url=baseUrl(`cites/dashboard?`)

        var search=this.state.search
        if((params["q1"])){
            search['txt_ncc']=params["q1"]
            url+="&q1="+params["q1"]

        }
        if((params["q2"])){
            search['sel_year']=params["q2"]
            url+="&q2="+params["q2"]

        }
        if((params["q3"])){
            search['sel_iucn']=params["q3"]
            url+="&q3="+params["q3"]

        }
        if((params["q4"])){
            search['sel_tiporecurso']=params["q4"]
            url+="&q4="+params["q4"]

        }

        this.setState({
            search: search            
        })

        this.setFilter()

        console.log('vvvvvvvvvvv', url)

        axios.get(url, {cancelToken: this.requestInit.token}).then(res => {
            // this.selects.cites = res.data.cites
            
            this.initpage(res.data);

        }).then(success => {
          // if (this.state.currentTab === 1) {  
            let h = document.getElementById('sel_cites')
            if (h) {
              h.dispatchEvent(new Event('change', {bubbles: true}));
            }

            if (this.paramsURL.byy !== undefined && this.paramsURL.byy > 0) {
              this.refSelectYear.current.value = this.paramsURL.byy
              this.onClick_btnGenerarYear()
            }
          // }
        })
        
        // this.generateChartsTab1({
        //   baseUrl: baseUrl(`cites/dashboard/charts`),
        // })
        this.initTypeahead()
    }

    setFilter(){
        this.setState({
            filter : {
                q1: this.state.search['txt_ncc'],
                q2: this.state.search['sel_year'],
                q3: this.state.search['sel_iucn'],
                q4: this.state.search['sel_tiporecurso']
            }
        })


        
    }
    initpage(result){
        var resultados = result;        
        
        var search=this.state.search
        const itemYear= resultados.years.map((item, ii) => {
            var selected=false
            if(this.state.search['sel_year'] === item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
            return (
                <option key={ii} value={item.exp_int_year} >{item.exp_int_year}</option>
            );
        })
        const itemPaises= resultados.paises.map((item, iii) => {
            var selected=false
            if(this.state.search['sel_iucn']==item.code){search["sel_iucn"]=item.code;selected=true}
            return (
                <option key={iii} value={item.code} >{item.name}</option>
            );
        })

        this.setState({
        //    mapsChartPais: this.createChart('GeoChart',
        //   [['Country', 'Popularity']],
        //   {
        //     // title: `Exportaciones  de ${this.state.currentDataEspecie.pli_txt_scientificname} en los últimos 10 años desde los PM`,
        //     // chartArea: { width: '50%' },
        //     // legend: {position: 'none', maxLines: 3},
        //     backgroundColor: this.BGMapChart
        //   }, {height: '30em'}
        // ),
            year: itemYear,
            paises: itemPaises,
            citesSelect: resultados.cites.map((item, index) => {
              var selected=false
              // if(this.state.search['sel_year'] === item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
              return (
                  <option key={ index } data-dataloaded={index === 0 ? 'true' : 'false'} value={item.var_txt_name.toString().toLowerCase()}>{ item.var_txt_description }</option>
              );
            }),
            // especiesSelect: resultados.especies.map((item, index) => {
            //   var selected=false
            //   // if(this.state.search['sel_year'] === item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
            //   return (
            //       <option key={ index } value={item.pli_int_id} selected={selected}>{item.pli_txt_scientificname}</option>
            //   );
            // }),
            search:search        
        })
        // this.getSearch()
       
        
    }

    onChange_especie = (evt) => {
      this.currentSelect.especie = evt.target.value
      
    }
    onChange_cites = (evt) => {
      
      this.currentSelect.cites = evt.target.value

      this.refSelectEspecies.current.disabled = true
      // if (this.state.currentTab === 1) {
        this.refSelectGrupos.current.value = '-1'
        this.refSelectEspecies.current.value = '-1'
        this.refSelectReyno.current.value = '-1'
        this.setState({
          especiesSelect: []
        })
        axios.get(baseUrl('cites/dashboard/getespecies'), {
          
          params: {cites: this.refSelectCites.current.value},
          cancelToken: this.requestInit.token
        }).then(res => {
          if (this.refSelectEspecies.current) {
            this.refSelectEspecies.current.disabled = false
          }
          this.setState({
            especiesSelect: res.data.data
          })
        })
      // }

    }
    COptionsReyno = () => {
      return this.state.especiesSelect.map(item => item.pli_txt_kingdom)
          .filter((a, b, c) => c.indexOf(a) === b)
          .sort((a, b) => {
            if (a > b) {
              return 1;
            }
            if (a < b) {
              return -1;
            }
            // a must be equal to b
            return 0;
          })
          .map((item, index) => {
            var selected=false
            // if(this.state.search['sel_year'] === item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
            return (
                <option key={ index } value={item} >{item}</option>
            );
          })
    }
    COptionsGrupos = () => {
      return this.state.especiesSelect
      .filter(item => {

        return this.state.filtersTabOne.reyno !== '-1' ? (item.pli_txt_kingdom === this.state.filtersTabOne.reyno) : true
      })
      .map(item => item.cgs_int_id)
      .filter((a, b, c) => c.indexOf(a) === b)
      
      .map((item, index) => {
        var selected=false
        // if(this.state.search['sel_year'] === item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
        let pd = this.state.especiesSelect.find(ii => ii.cgs_int_id === item)
        let cantidad = 0
        this.state.especiesSelect.forEach(iEs => {
          if (item === iEs.cgs_int_id) {
            cantidad++
          }
        })
        return {cgs_int_id: pd.cgs_int_id, cgs_txt_name: pd.cgs_txt_name, cantidad }
      })
      .sort((a, b) => {
        if (a.cgs_txt_name > b.cgs_txt_name) {
          return 1;
        }
        if (a.cgs_txt_name < b.cgs_txt_name) {
          return -1;
        }
        // a must be equal to b
        return 0;
      })
      .map((item, index, array) => {
        
        var selected=false
        // if(this.state.search['sel_year'] === item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
        
        return (
            <option key={ index } value={item.cgs_int_id} >{item.cgs_txt_name} ({ item.cantidad })</option>
        );
      })
    }
    COptionsEspecies = () => {
      return this.state.especiesSelect
      .filter(item => {
        if (this.state.filtersTabOne.reyno !== '-1' && +this.state.filtersTabOne.grupo !== -1) {
          // console.log('---AA', item.cgs_int_id, this.state.filtersTabOne.grupo)
          // console.log('---BB', item.pli_txt_kingdom, this.state.filtersTabOne.reyno)
          return item.pli_txt_kingdom === this.state.filtersTabOne.reyno  && item.cgs_int_id === this.state.filtersTabOne.grupo
        }

        if (this.state.filtersTabOne.reyno !== '-1') {
          // console.log('BB', item.pli_txt_kingdom, this.state.filtersTabOne.reyno)
          return item.pli_txt_kingdom === this.state.filtersTabOne.reyno
        }

        if (+this.state.filtersTabOne.grupo !== -1) {
          // console.log('CC', item.cgs_int_id, this.state.filtersTabOne.grupo)
          return item.cgs_int_id === this.state.filtersTabOne.grupo
        }
        return true
      })
      .map((item, index) => {
        var selected=false
        // if(this.state.search['sel_year'] === item.exp_int_year){search["sel_year"]=item.exp_int_year;selected=true}
        return (
            <option key={ index } value={item.pli_int_id} >{item.pli_txt_scientificname}</option>
        );
      })
    }
    getLastYearsOption = () => {
      let cdate = new Date()
      let years = []
      for(let i = cdate.getFullYear() - 10; i <= cdate.getFullYear(); i++) {
        years.push(<option key={ i } value={ i }>{ i }</option>)
      }
      return years
    }
    onClick_btnGenerarYear = (evt) => {




      this.setState({
        chartListYear: {
          aperture: false,
          showGenerar: false,
          AA: SpinLoaderStyle,
          A: SpinLoaderStyle,
          B: SpinLoaderStyle,
          IA: SpinLoaderStyle,
          IB: SpinLoaderStyle,
          IC: SpinLoaderStyle,
          YPA: SpinLoaderStyle,
          YPB: SpinLoaderStyle,
          YDA: SpinLoaderStyle,
          YDB: SpinLoaderStyle,
        },
      })

      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          // especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYAA'
        },
        cancelToken: this.requestInit.token
      }).then( res => {
        let especies = res.data.data.values
          .map(item => item.especie)
          .filter((a, b, c) => c.indexOf(a) === b)
          .map(item => {
            let total = 0
            res.data.data.values.forEach(val => {
              if (val.especie === item) {
                total += +val.cantidad
              }
            })
            return {e: item, t: total}
          })
          .sort((a, b) => b.t - a.t)
          .map(item => item.e)
        let paises = res.data.data.values
          .sort((a, b) => +b.pais_order - +a.pais_order)
          .map(item => item.pais)
          .filter((a, b, c) => c.indexOf(a) === b)
        let dataParseAA = []

        dataParseAA = paises.map(itemPais => {
            let preData = new Array(especies.length)
            let totales = 0
              preData.fill(0)
              res.data.data.values.forEach((itemValue, indexValue, thisArray) => {
                if (itemValue.pais.trim() === itemPais.trim()) {
                  especies.forEach((itemEspecie, indexEspecie) => {
                    if (itemEspecie.trim() === itemValue.especie.trim()) {
                      preData[indexEspecie] = +itemValue.cantidad
                      totales += +itemValue.cantidad
                      // thisArray.splice(indexValue, 1)
                    }
                  })
                }
              })

            return {
              name: itemPais,
              data: preData,
              totales: totales
            }
          })
        
        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            AA: res.data.data.values.length > 0 ?  this.createChart2('chartYAA',
              {
                  exporting: {enabled: false},
                  chart: { type: 'bar' },
                  title: {
                      text: `Las 10 especies más exportadas en el año ${this.refSelectYear.current.value} de los Países Miembros`
                  },
                  xAxis: { title: { text: 'Especies' }, categories: especies },
                  yAxis: {
                      min: 0,
                      title: {
                          text: 'Cantidad'
                      }
                  },
                  legend: { reversed: true },
                  plotOptions: {
                      series: {
                          stacking: 'normal'
                      }
                  },
                  series: dataParseAA
              }
            ) : null          
          }
        })
      })

      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYA'
        },
        cancelToken: this.requestInit.token
      }).then( res => {
        // let especies = res.data.data.values.map(item => item.especie).filter((a, b, c) => c.indexOf(a) === b)
        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            A: res.data.data.values.length > 0 ? this.createChart2('chartYA', {
              legend: false,
               exporting: {enabled: false},
              // chart: { type: 'bar' },
              title: {
                  text: `Exportaciones desde los Países Miembros en el año ${this.refSelectYear.current.value}`
              },
              xAxis: { title: 'Especies', categories: [...res.data.data.values.map(item => item.pais)] },
              yAxis: {
                  min: 0,
                  title: {
                      text: 'Cantidad'
                  }
              },
              // legend: { reversed: true },
              series: [{type: 'column', name: 'Cantidad', data: [...res.data.data.values.map(itemS => +itemS.cantidad)]}]
            }
              // [['Pais', 'Cantidad'], ...res.data.data.values.map(item => [item.pais, +item.cantidad])],
              // {
              //   title: `Exportaciones los Países Miembros en el año ${this.refSelectYear.current.value}`,
              //   // chartArea: { width: '50%' },
              //   legend: {position: 'none'},
              //   hAxis: {
              //     title: 'Pais',
              //     minValue: 0,
              //   },
              //   isStacked: false,
              //   vAxis: {
              //     title: 'Cantidad',
              //   },
              // }
            ): null            
          }
        })
      })

      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYB'
        },
        cancelToken: this.requestInit.token
      }).then( res => {

        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            B: res.data.data.values.length > 0 ? this.createChart2('chartYB',
            {
              chart: { type: 'pie' },
              title: { text: `Las 10 presentaciones más exportadas de los Países Miembros en el año ${this.refSelectYear.current.value}` },
              plotOptions: {
                  pie: {
                      allowPointSelect: true,
                      cursor: 'pointer',
                      dataLabels: {
                          enabled: true,
                          format: '{point.percentage:.2f}%',
                          distance: -50,
                      },
                      showInLegend: true
                  }
              },
              series: [{
                  name: 'Cantidad',
                  //colorByPoint: true,
                  data: [...res.data.data.values.map(item => {return {name: item.termino, y: +item.cantidad} })]
              }]
            }
              ) : null
          }
        })
      })

      // resumen importacion

      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          // especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYIA'
        },
        cancelToken: this.requestInit.token
      }).then( res => {
        let especies = res.data.data.values
          .map(item => item.especie)
          .filter((a, b, c) => c.indexOf(a) === b)
          .map(item => {
            let total = 0
            res.data.data.values.forEach(val => {
              if (val.especie === item) {
                total += +val.cantidad
              }
            })
            return {e: item, t: total}
          })
          .sort((a, b) => b.t - a.t)
          .map(item => item.e)
        let paises = res.data.data.values.map(item => item.pais).filter((a, b, c) => c.indexOf(a) === b)
        let dataParseAA = [['Especie', ...paises]]

       
       dataParseAA = paises.map(itemPais => {
            let preData = new Array(especies.length)
              preData.fill(0)
              res.data.data.values.forEach((itemValue, indexValue, thisArray) => {
                if (itemValue.pais.trim() === itemPais.trim()) {
                  especies.forEach((itemEspecie, indexEspecie) => {
                    if (itemEspecie.trim() === itemValue.especie.trim()) {
                      preData[indexEspecie] = +itemValue.cantidad
                      // thisArray.splice(indexValue, 1)
                    }
                  })
                }
              })

            return {
              name: itemPais,
              data: preData
            }
          })
        
        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            IA: res.data.data.values.length > 0 ?  this.createChart2('chartYIA',
                {
                  exporting: {enabled: false},
                  chart: { type: 'bar' },
                  title: {
                      text: `Las 10 especies más importadas en el año ${this.refSelectYear.current.value} desde los Países Miembros`
                  },
                  xAxis: { title: 'Especies', categories: especies },
                  yAxis: {
                      min: 0,
                      title: {
                          text: 'Cantidad'
                      }
                  },
                  legend: { reversed: true },
                  plotOptions: {
                      series: {
                          stacking: 'normal'
                      }
                  },
                  series: dataParseAA
              }
            ) : null            
          }
        })
      })
      
      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYIB'
        },
        cancelToken: this.requestInit.token
      }).then( res => {

        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            IB: res.data.data.values.length > 0 ? this.createChart2('chartYIB',
            {
              legend: false,
               exporting: {enabled: false},
              // chart: { type: 'bar' },
              title: {
                  text: `Importaciones desde los Países Miembros en el año ${this.refSelectYear.current.value}`
              },
              xAxis: { title: 'Especies', categories: [...res.data.data.values.map(item => item.pais)] },
              yAxis: {
                  min: 0,
                  title: {
                      text: 'Cantidad'
                  }
              },
              series: [{type: 'column', name: 'Cantidad', data: [...res.data.data.values.map(itemS => +itemS.cantidad)]}]
            }
            ): null            
          }
        })
      })

      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYIC'
        },
        cancelToken: this.requestInit.token
      }).then( res => {

        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            IC: res.data.data.values.length > 0 ? this.createChart2('chartYIC',
                {
                  chart: { type: 'pie' },
                  title: { text: `Las 10 presentaciones más importadas de los Países Miembros en el año ${this.refSelectYear.current.value}` },
                  plotOptions: {
                      pie: {
                          allowPointSelect: true,
                          cursor: 'pointer',
                          dataLabels: {
                              enabled: true,
                              format: '{point.percentage:.2f}%',
                              distance: -50,
                          },
                          showInLegend: true
                      }
                  },
                  series: [{
                      name: 'Cantidad',
                      //colorByPoint: true,
                      data: [...res.data.data.values.map(item => {return {name: item.termino, y: +item.cantidad} })]
                  }]
                }
              ) : null
          }
        })
      })
      // permisos
      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          // especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYPA'
        },
        cancelToken: this.requestInit.token
      }).then( res => {
        let especies = res.data.data.values
          .map(item => item.especie)
          .filter((a, b, c) => c.indexOf(a) === b)
        let paises = res.data.data.values
          .sort((a, b) => +a.pais_order - +b.pais_order)
          .map(item => item.pais)
          .filter((a, b, c) => c.indexOf(a) === b)
        let dataParseAA = [['Especie', ...paises]]

       
       dataParseAA = paises.map(itemPais => {
            let preData = new Array(especies.length)
              preData.fill(0)
              res.data.data.values.forEach((itemValue, indexValue, thisArray) => {
                if (itemValue.pais.trim() === itemPais.trim()) {
                  especies.forEach((itemEspecie, indexEspecie) => {
                    if (itemEspecie.trim() === itemValue.especie.trim()) {
                      preData[indexEspecie] = +itemValue.cantidad
                      // thisArray.splice(indexValue, 1)
                    }
                  })
                }
              })

            return {
              name: itemPais,
              data: preData
            }
          })
        
        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            YPA: res.data.data.values.length > 0 ?  this.createChart2('chartYPA',
                {
                  exporting: {enabled: false},
                  chart: { type: 'bar' },
                  title: {
                      text: `Cantidad de permisos de exportación en el año ${this.refSelectYear.current.value} de las 10 primeras especies de los Países Miembros`
                  },
                  xAxis: { title: 'Especies', categories: especies },
                  yAxis: {
                      min: 0,
                      title: {
                          text: 'Cantidad'
                      }
                  },
                  // legend: { reversed: true },
                  plotOptions: {
                      series: {
                          stacking: 'normal'
                      }
                  },
                  series: dataParseAA
              }
            ) : null            
          }
        })
      })
      
      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYPB'
        },
        cancelToken: this.requestInit.token
      }).then( res => {

        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            YPB: res.data.data.values.length > 0 ? this.createChart2('chartYPB',
            {
              legend: false,
               exporting: {enabled: false},
              // chart: { type: 'bar' },
              title: {
                  text: `Cantidad de permisos de exportación en el año ${this.refSelectYear.current.value} desde los Países Miembros`
              },
              xAxis: { title: 'Especies', categories: [...res.data.data.values.map(item => item.pais)] },
              yAxis: {
                  min: 0,
                  title: {
                      text: 'Cantidad'
                  }
              },
              series: [{type: 'column', name: 'Cantidad', data: [...res.data.data.values.map(itemS => +itemS.cantidad)]}]
            }
            ): null            
          }
        })
      })

      // decomisos
      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          // especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYDA'
        },
        cancelToken: this.requestInit.token
      }).then( res => {
        let especies = res.data.data.values
          .map(item => item.especie)
          .filter((a, b, c) => c.indexOf(a) === b)
          .map(item => {
            let total = 0
            res.data.data.values.forEach(val => {
              if (val.especie === item) {
                total += +val.cantidad
              }
            })
            return {e: item, t: total}
          })
          .sort((a, b) => b.t - a.t)
          .map(item => item.e)
        let paises = res.data.data.values.map(item => item.pais).filter((a, b, c) => c.indexOf(a) === b)
        let dataParseAA = [['Especie', ...paises]]

       
       dataParseAA = paises.map(itemPais => {
            let preData = new Array(especies.length)
              preData.fill(0)
              res.data.data.values.forEach((itemValue, indexValue, thisArray) => {
                if (itemValue.pais.trim() === itemPais.trim()) {
                  especies.forEach((itemEspecie, indexEspecie) => {
                    if (itemEspecie.trim() === itemValue.especie.trim()) {
                      preData[indexEspecie] = +itemValue.cantidad
                      // thisArray.splice(indexValue, 1)
                    }
                  })
                }
              })

            return {
              name: itemPais,
              data: preData
            }
          })
        
        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            YDA: res.data.data.values.length > 0 ?  this.createChart2('chartYDA',
                {
                  exporting: {enabled: false},
                  chart: { type: 'bar' },
                  title: {
                      text: `Cantidad de decomisos de exportación en el año ${this.refSelectYear.current.value} de las 10 primeras especies de los Países Miembros`
                  },
                  xAxis: { title: 'Especies', categories: especies },
                  yAxis: {
                      min: 0,
                      title: {
                          text: 'Cantidad'
                      }
                  },
                  legend: { reversed: true },
                  plotOptions: {
                      series: {
                          stacking: 'normal'
                      }
                  },
                  series: dataParseAA
              }
            ) : null            
          }
        })
      })
      
      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          year: this.refSelectYear.current.value,
          especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim(),
          target: 'chartYDB'
        },
        cancelToken: this.requestInit.token
      }).then( res => {

        this.setState({
          chartListYear: {
            ...this.state.chartListYear,
            aperture: true,
            showGenerar: true,
            YDB: res.data.data.values.length > 0 ? this.createChart2('chartYDB',
            {
              legend: false,
               exporting: {enabled: false},
              // chart: { type: 'bar' },
              title: {
                  text: `Cantidad de decomisos de exportación en el año ${this.refSelectYear.current.value} desde los Países Miembros`
              },
              xAxis: { title: 'Especies', categories: [...res.data.data.values.map(item => item.pais)] },
              yAxis: {
                  min: 0,
                  title: {
                      text: 'Cantidad'
                  }
              },
              series: [{type: 'column', name: 'Cantidad', data: [...res.data.data.values.map(itemS => +itemS.cantidad)]}]
            }
            ): null            
          }
        })
      })
    }
    pointsToPath = (from, to, invertArc = true) => {
      console.log('toooooooo', to)
      var arcPointX = (from.x + to.x) / (invertArc ? 2.4 : 1.6),
          arcPointY = (from.y + to.y) / (invertArc ? 2.4 : 1.6);
      let g = 'M' + from.x + ',' + from.y + 'Q' + arcPointX + ' ' + arcPointY + ',' + to.x + ' ' + to.y;
      
      return g
    }
    onClick_btnGenerarPais = (evt) => {
      this.setState({
        chartListPais: {
          aperture: false,
          showGenerar: false,
          A: SpinLoaderStyle,
          B: SpinLoaderStyle,
        },
        mapsChartPais: SpinLoaderStyle,
        especiesMasExportadasTab3: [],
      })
      let selYearTT = this.refSelectPaisYear.current.value
      axios.get(baseUrl(`cites/dashboard/charts`), {
        params: {
          pais: this.refSelectPais.current.value,
          year: selYearTT,
          target: 'mappaisexporta'
        },
        cancelToken: this.requestInit.token
      }).then( res => {

      //   let dataFormat = [['Pais', 'Cantidad'], ...res.data.data.values.map(item => {
      //     return [item.pais, +item.cantidad]
      //   })]

      
      let paises = []
      paises.push({
              name: res.data.data.latLongCodPais[3],
              id: res.data.data.latLongCodPais[2],
              lat: res.data.data.latLongCodPais[0],
              lon: res.data.data.latLongCodPais[1],
            })
      res.data.data.values.map((ii, index) => {
        ii.color = Highcharts.getOptions().colors[index]
        return ii
      }).forEach((itemV, index) => {
        
        itemV.destino.forEach(itemD => {
          let target = paises.find(itemP => itemP.id.toString().trim().toUpperCase() === itemD.exp_txt_importer.toString().trim().toUpperCase())
          if (target === undefined) {
            paises.push({
              name: itemD.pais,
              id: itemD.exp_txt_importer.toString().trim().toUpperCase(),
              lat: itemD.latLong[0] !== undefined ? itemD.latLong[0] : 0,
              lon: itemD.latLong[1] !== undefined ? itemD.latLong[1] : 0,
            })
          }
        })
      })
      // console.log('LUNA', Highcharts.geojson(Highcharts.maps['custom/world'], 'mapline'))
      // console.log('ccccccccccccc', Highcharts.maps['custom/world'])
      this.setState({
        chartListPais: {
          aperture: true,
          showGenerar: true,
        },
        especiesMasExportadasTab3: res.data.data.values,
        mapsChartPais: res.data.data.values.length > 0 ? this.createChartMaps3('GeoChartYYY', {

          title: {
            text: `Exportaciones  de especies de ${res.data.data.latLongCodPais[3]} en ${ selYearTT > 0 ? 'el año ' + selYearTT : 'los últimos 10 años'} de los Países Miembros`
          },

          legend: {
            align: 'left',
            layout: 'vertical',
            floating: true
          },

          mapNavigation: {
            enabled: true
          },

          tooltip: {
            formatter: function () {
              return this.point.name
              // return this.point.name + (
              //   this.point.lat ?
              //   '<br>Lat: ' + this.point.lat + ' Lon: ' + this.point.lon : ''
              // );
            }
          },

          plotOptions: {
            series: {
              events: {
                legendItemClick: function() {
                  
                  var seriesIndex = this.index;
                  var series      = this.chart.series;
                    if (this.visible && this.chart.restIsHidden) {
                        
                        series.forEach(function(item, index){
                            if (!['Basemap', 'Pais'].includes(item.name))
                              item.setVisible(true, false);
                        });
                        this.chart.restIsHidden = false;
                      } else {
                        
                        series.forEach(function(item, index){
                          if (!['Basemap', 'Pais'].includes(item.name))
                            item.setVisible(false, false);
                        });
                        this.show()
                        this.chart.restIsHidden = true;
                      }
                      return false;
                    }
                },
              marker: {
                fillColor: '#FFFFFF',
                lineWidth: 2,
                lineColor: '#434348'
              }
            }
          },

          series: [{
            // Use the gb-all map with no data as a basemap
            mapData: Highcharts.maps['custom/world'],
            // mapData: [],
            name: 'Basemap',
            data: [[res.data.data.latLongCodPais[2].toLowerCase(), 1]],
            borderColor: '#707070',
            nullColor: 'rgba(200, 200, 200, 0.3)',
            showInLegend: false
          }, {
            name: 'Separators',
            type: 'mapline',
            data: Highcharts.geojson(Highcharts.maps['custom/world'], 'mapline'),
            // data: [],
            color: '#707070',
            showInLegend: false,
            enableMouseTracking: false
          }, {
            // Specify cities using lat/lon
            type: 'mappoint',
            name: 'Pais',
            dataLabels: {
              format: '{point.name}'
            },
            // Use id instead of name to allow for referencing points later using
            // chart.get
            /* -9.189967,
                  -75.015152, */
            data: paises
          },
        
        ]

        }, [], chartRes => {
          this.chartMapGlobal = chartRes
          console.log('chartRes',chartRes, chartRes.get('US'))
          // console.log('chartRes', chartRes.get('Birmingham'))
          var origen = chartRes.get(this.refSelectPais.current.value.toString().toUpperCase())
          res.data.data.values.forEach(itemVV => {
            let preD = {
              id: itemVV.exp_txt_taxon,
              name: itemVV.exp_txt_taxon + `(${itemVV.cantidad})`,
              type: 'mapline',
              lineWidth: 4,
              color: itemVV.color,
              data: [],
              // dataLabels: {
              //   enabled: true,
              //   formatter: function () {
              //     console.log('hhhhhhhh', this)
              //     return `${this.point.total}`
              //   }
              // },
            }
            itemVV.destino.forEach(itemDD => {
              let destino = chartRes.get(itemDD.exp_txt_importer)
              let idd = `${origen.options.name} - ${destino.options.name}`
              preD.data.push({
                  id: idd + 'hhshh',
                  name: `${idd}, Total: ${itemDD.cantidad}`,
                  total: +itemDD.cantidad,
                  path: this.pointsToPath(origen, destino)
              })
            })
            chartRes.addSeries(preD);

          })
          
        }) : null,
        A: res.data.data.values.length > 0 ?  this.createChart2('chartPYA',
          {
              exporting: {enabled: false},
              chart: { type: 'bar' },
              title: {
                  text: `Las 10 especies más exportadas en el año ${this.refSelectPais.current.value} de los Países Miembros`
              },
              xAxis: { title: { text: 'Especies' }, categories: [] },
              yAxis: {
                  min: 0,
                  title: {
                      text: 'Cantidad'
                  }
              },
              legend: { reversed: true },
              plotOptions: {
                  series: {
                      stacking: 'normal'
                  }
              },
              series: []
          }
        ) : null,
        B: res.data.data.values.length > 0 ?  this.createChart2('chartPYB',
          {
              exporting: {enabled: false},
              chart: { type: 'bar' },
              title: {
                  text: `Las 10 especies más exportadas en el año ${this.refSelectPais.current.value} de los Países Miembros`
              },
              xAxis: { title: { text: 'Especies' }, categories: [] },
              yAxis: {
                  min: 0,
                  title: {
                      text: 'Cantidad'
                  }
              },
              legend: { reversed: true },
              plotOptions: {
                  series: {
                      stacking: 'normal'
                  }
              },
              series: []
          }
        ) : null 
      })
      // this.setState({
      //   especiesMasExportadasTab3: res.data.data.values,
      //   mapsChartPais: this.createChartMaps3('GeoChart',
      //   dataFormat,
      //   {
      //     backgroundColor: this.BGMapChart
      //     // title: `Exportaciones  de ${this.state.currentDataEspecie.pli_txt_scientificname} en los últimos 10 años desde los PM`,
      //     // chartArea: { width: '50%' },
      //     // legend: {position: 'none', maxLines: 3},

      //   }, {height: '30em'}
      // )
      // })
      })
    }

    onClick_panelToogle = (target, hh) => {
      return e => {
        e.preventDefault()
        console.log('click', e, target, hh)
      }
    }
    getImageDistribution = () => {
      
      
    }
    generateChartsTab1 = (data) => {
     
      let predata = {
        cite: this.currentSelect.cite,
        especie: this.state.currentDataEspecie.pli_txt_scientificname.toString().toLowerCase().trim()
      }
 

      this.setState({
        mapsChartDistribution: this.createChartMaps3('GeoChartTTT', 
        {
          chart: {
              map: Highcharts.maps['custom/south-america']
          },
      
          title: {
              text: 'Distribution',
              style: {display: 'none'}
          },
          legend: {
            enabled: false
          },
          tooltip: {
            enabled: false
          },
          colorAxis: {
              min: 0
          },
      
          series: [{
              data: this.state.currentDataEspecie.pli_txt_distribution.split(',').map((cpitem, index) => {

                    // let opais = this.state.currentDataEspeciePaises.find(op =>  op.code.trim() === cpitem.trim())
                    // return [{v: cpitem.trim(), f: opais ? opais.name : cpitem.trim()}, index]
                    return [cpitem.trim().toLowerCase(), 1]
              }),
              name: 'Random data',
              states: {
                  hover: {
                      color: '#BADA55'
                  }
              },
              dataLabels: {
                  enabled: true,
                  format: ''
              }
          }]
        }, [], chartRes => {}),

      //   mapsChartDistribution: this.createChart('GeoChart',
      //   [['Country', ''], ...this.state.currentDataEspecie.pli_txt_distribution.split(',').map(cpitem => {

      //     let opais = this.state.currentDataEspeciePaises.find(op =>  op.code.trim() === cpitem.trim())
      //     return [{v: cpitem.trim(), f: opais ? opais.name : cpitem.trim()}, {v: 1, f:''}]
      //   })],
      //   {
      //     // height: 100,
      //     // keepAspectRatio: false,
      //     // title: `Exportaciones  de ${this.state.currentDataEspecie.pli_txt_scientificname} en los últimos 10 años desde los PM`,
      //     // chartArea: { width: '50%' },
      //     region: '005',
      //     legend: 'none',
          
      //   }, 
      // )
      })
      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartAB',
        }
      }).then(res => {
        // let dataParseA = []
        let copy = [...res.data.data.values]
        let copyB = [...res.data.data.values]
        let years =  []
        let {minyear, maxyear} = res.data.data.extra
        for (let x = maxyear; x >= minyear; x-- ) {
          years.push(x.toString())
        }
        let paises =  copy.sort((a, b) => +a.pais_order - +b.pais_order).map(item => item.pais).filter((a, b, c) => c.indexOf(a) === b)
        // let dataParseA = [["Año",...paises]]
        let dataParseA = []
        let dataParseB = []
        
        paises.forEach((itemP, indexP) => {
          let preRow = new Array(years.length)
          preRow.fill(0)

          years.forEach((item, index) => {
            let f = copy.findIndex(itemD => {
              return itemD.pais === itemP && itemD.exp_int_year === item
            })
            if (f >= 0) {
              preRow[index] = +copy[f].cantidad
              // copy.splice(f, 1)
            }
          })
          dataParseA.push({name: itemP, data: preRow})
        })

        
        
        paises.forEach((itemP, indexP) => {
          let preRow = [itemP, 0]
          copyB.forEach((itemD, index) => {
            if (itemD.pais === itemP) {
              preRow[1] += +itemD.cantidad
              // copyB.splice(index, 1)
            }
          })
          dataParseB.push(preRow)
        })
        
        
        dataParseB = dataParseB.sort((a, b) => +b[1] - +a[1])
        this.setState({
          chartList: {
            ...this.state.chartList,
            aperture: true,
            showGenerar: true,
            A: res.data.data.values.length > 0 ? this.createChart2('BarChartA',
              {
                  chart: { type: 'bar' },
                  title: {
                      useHTML: false,
                      text: `Número de Operaciones de exportaciones por año de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> en los últimos 10 años desde los Países Miembros`
                  },
                  xAxis: { title: {text: 'Años'}, categories: years },
                  yAxis: {
                      min: 0,
                      title: {
                          text: 'Cantidad'
                      }
                  },
                  // legend: { reversed: true },
                  plotOptions: {
                      series: {
                          stacking: 'normal'
                      }
                  },
                  series: dataParseA
              },

            ) : null,
            B: res.data.data.values.length > 0 ? this.createChart2('ColumnChartB',
              {
                legend: false,
                exporting: {enabled: false},
                // chart: { type: 'bar' },
                title: {
                    text: `Número de Operaciones de exportaciones de  <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> en los últimos 10 años desde los Países Miembros`
                },
                xAxis: { title: { text: 'Países' }, categories: [...dataParseB.map(item => item[0])] },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Cantidad'
                    }
                },
                // legend: { reversed: true },
                series: [{type: 'column', 
                name: 'Cantidad', 
                dataSorting: {
                  // enabled: true,
                  // sortKey: 'custom.value'
                },
                colorByPoint: true, data: [...dataParseB.map(itemS => +itemS[1])]}]
              },
           
            ) : null

            
          }
        })
      })
      // START BB
      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartBB',
        }
      }).then(res => {
        
        // let terminos = res.data.data.values
        //   .map(item => item.termino)
        //   .filter((a, b, c) => c.indexOf(a) === b)
        //   .map(item => {
        //     let r = {name: item, y: 0}
        //     res.data.data.values.forEach(value => {
        //       if (value.termino === item) {
        //         r.y += +value.cantidad
        //       }
        //     })
        //     return r
        //   })
        let predata = res.data.data.values.sort((a, b) => {
          return +b.cantidad - +a.cantidad
        })
        // res.data.data.values
        this.setState({
          chartList: {
            ...this.state.chartList,
            aperture: true,
            showGenerar: true,
            BB: res.data.data.values.length > 0 ? this.createChart2('ColumnChartBB',
              {
                legend: false,
                exporting: {enabled: false},
                // chart: { type: 'bar' },
                title: {
                    text: `Destinos con mayor número de operaciones  de  <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> en los 10 últimos años desde los Países Miembros`
                },
                xAxis: { title: {text: 'Países'}, categories: predata.map(item => item.pais) },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Cantidad'
                    }
                },
                // legend: { reversed: true },
                series: [{
                  type: 'column', name: 'Cantidad', 
                  dataSorting: {
                    // enabled: true,
                    // sortKey: 'custom.value'
                  },
                  colorByPoint: true, data: predata.map(itemS => +itemS.cantidad)}]
              },
              
              ) : null
          }
        })
      })
      // END BB
      // START CHART C
      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartC',
        }
      }).then(res => {
        
        let terminos = res.data.data.values
          .map(item => item.termino)
          .filter((a, b, c) => c.indexOf(a) === b)
          .map(item => {
            let r = {name: item, y: 0}
            res.data.data.values.forEach(value => {
              if (value.termino === item) {
                r.y += +value.cantidad
              }
            })
            return r
          })
     
        
        this.setState({
          chartList: {
            ...this.state.chartList,
            aperture: true,
            showGenerar: true,
            C: res.data.data.values.length > 0 ? this.createChart2('PieChartC',
               {
                  chart: { type: 'pie' },
                  title: { text: `Número de Operaciones de exportaciones  de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> por tipo de presentación en últimos 10 años de los Países Miembros` },
                  plotOptions: {
                      pie: {
                          allowPointSelect: true,
                          cursor: 'pointer',
                          dataLabels: {
                              // enabled: false,
                              enabled: true,
                              format: '{point.percentage:.2f}%',
                              distance: -50,
                              // filter: {
                              //     property: 'percentage',
                              //     operator: '>',
                              //     value: 4
                              // }
                          },
                          showInLegend: true
                      }
                  },
                  series: [{
                      name: 'Cantidad',
                      // data: [...res.data.data.values.map(item => {return {name: item.termino, y: +item.cantidad} })]
                      data: terminos
                  }]
                },
              ) : null
          }
        })
      })
      // END CHART C

      //importaciones

      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartDE',
        }
      }).then(res => {
        // let dataParseA = []
        let copy = [...res.data.data.values]
        let copyB = [...res.data.data.values]
        let years =  []
        let {minyear, maxyear} = res.data.data.extra
        for (let x = maxyear; x >= minyear; x-- ) {
          years.push(x.toString())
        }
        let paises =  copy.sort((a, b) => +a.pais_order - +b.pais_order).map(item => item.pais).filter((a, b, c) => c.indexOf(a) === b)
        // let dataParseA = [["Año",...paises]]
        let dataParseA = []
        // let dataParseB = [["Pais", "Cantidad"]]
        let dataParseB = []
        
        paises.forEach((itemP, indexP) => {
          let preRow = new Array(years.length)
          preRow.fill(0)

          years.forEach((item, index) => {
            let f = copy.findIndex(itemD => {
              return itemD.pais === itemP && itemD.exp_int_year === item
            })
            
            if (f >= 0) {
              preRow[index] = +copy[f].cantidad
              // copy.splice(f, 1)
            }
          })
          dataParseA.push({name: itemP, data: preRow})
        })

        
        
        paises.forEach((itemP, indexP) => {
          let preRow = [itemP, 0]
          copyB.forEach((itemD, index) => {
            if (itemD.pais === itemP) {
              preRow[1] += +itemD.cantidad
              // copyB.splice(index, 1)
            }
          })
          dataParseB.push(preRow)
        })
        
        dataParseB = dataParseB.sort((a, b) => +b[1] - +a[1])
        this.setState({
          chartList: {
            ...this.state.chartList,
            D: res.data.data.values.length > 0 ? this.createChart2('BarChartD',
              {
                  chart: { type: 'bar' },
                  title: {
                      text: `Número de Operaciones de Importaciones por año de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> en los últimos 10 años desde los Países Miembros`
                  },
                  xAxis: { title: {text: 'Años'}, categories: years },
                  yAxis: {
                      min: 0,
                      title: {
                          text: 'Cantidad'
                      }
                  },
                  // legend: { reversed: true },
                  plotOptions: {
                      series: {
                          stacking: 'normal'
                      }
                  },
                  series: dataParseA
              },
           
            ) : null,
            E: res.data.data.values.length > 0 ? this.createChart2('ColumnChartE',
              {
                legend: false,
                exporting: {enabled: false},
                // chart: { type: 'bar' },
                title: {
                    text: `Número de Operaciones de importaciones de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> en los últimos 10 años de los Países Miembros`
                },
                xAxis: { title: { text: 'Países' }, categories: [...dataParseB.map(item => item[0])] },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Cantidad'
                    }
                },
                // legend: { reversed: true },
                series: [{type: 'column', 
                colorByPoint: true, name: 'Cantidad', 
                dataSorting: {
                  // enabled: true,
                  // sortKey: 'custom.value'
                },
                data: [...dataParseB.map(itemS => +itemS[1])]}]
              },
            ) : null

            
          }
        })
      })
      // END D y E

      // START DD
      
      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartDD',
        }
      }).then(res => {
        
        let terminos = res.data.data.values
          .map(item => item.termino)
          .filter((a, b, c) => c.indexOf(a) === b)
          .map(item => {
            let r = {name: item, y: 0}
            res.data.data.values.forEach(value => {
              if (value.termino === item) {
                r.y += +value.cantidad
              }
            })
            return r
          })
        let resPreDD = res.data.data.values.sort((a, b) => +b.cantidad - +a.cantidad)
          
        this.setState({
          chartList: {
            ...this.state.chartList,
            aperture: true,
            showGenerar: true,
            DD: res.data.data.values.length > 0 ? this.createChart2('ColumnChartDD',
              {
                legend: false,
                exporting: {enabled: false},
                // chart: { type: 'bar' },
                title: {
                    text: `Destinos con más importaciones de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> en los 10 últimos años desde los Países Miembros`
                },
                xAxis: { title: {text: 'Países'}, categories: resPreDD.map(item => item.pais) },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Cantidad'
                    }
                },
                // legend: { reversed: true },
                series: [{type: 'column', 
                dataSorting: {
                  // enabled: true,
                  // sortKey: 'custom.value'
                },
                name: 'Cantidad', colorByPoint: true, data: resPreDD.map(itemS => +itemS.cantidad)}]
              },
              
              ) : null
          }
        })
      })
      //END DD
      //F
      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartF',
        }
      }).then(res => {
        
        let terminos = res.data.data.values
        .map(item => item.termino)
        .filter((a, b, c) => c.indexOf(a) === b)
        .map(item => {
          let r = {name: item, y: 0}
          res.data.data.values.forEach(value => {
            if (value.termino === item) {
              r.y += +value.cantidad
            }
          })
          return r
        })
        
        this.setState({
          chartList: {
            ...this.state.chartList,
            F: res.data.data.values.length > 0 ? this.createChart2('PieChartF',
            {
                chart: { type: 'pie' },
                title: { text: `Número de Operaciones de importaciones  de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> por tipo de presentación en últimos 10 años de los Países Miembros` },
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                          enabled: true,
                          format: '{point.percentage:.2f}%',
                          distance: -50,
                        },
                        showInLegend: true
                    }
                },
                series: [{
                    name: 'Cantidad',
                    // data: [...res.data.data.values.map(item => {return {name: item.termino, y: +item.cantidad} })]
                    data: terminos
                }]
              },
              ) : null
          }
        })
      })


      //G
      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartG',
        }
      }).then(res => {
        // let dataParseA = []
        // let copy = [...res.data.data.values]
        let dataParseB = [...res.data.data.values.map(item => [item.pais, +item.cantidad])]
        dataParseB = dataParseB.sort((a, b) => +b[1] - +a[1])

        this.setState({
          chartList: {
            ...this.state.chartList,
            G: res.data.data.values.length > 0 ? this.createChart2('ColumnChartG',
               {
                legend: false,
                exporting: {enabled: false},
                // chart: { type: 'bar' },
                title: {
                    text: `Número de Permisos de Exportación de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> por país`
                },
                xAxis: { title: {text: 'Países' }, categories: [...dataParseB.map(item => item[0])] },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Cantidad'
                    }
                },
                // legend: { reversed: true },
                series: [{type: 'column', 
                 dataSorting: {
                    // enabled: true,
                    // sortKey: 'custom.value'
                  },
                name: 'Cantidad', data: [...dataParseB.map(itemS => +itemS[1])]}]
              }
            ) : null

            
          }
        })
      })

      //H
      axios.get(data.baseUrl, {
        params: {
          ...predata,
          target: 'chartH',
        }
      }).then(res => {
        // let dataParseA = []
        // let copy = [...res.data.data.values]
        let dataParseB = [...res.data.data.values.map(item => [item.pais, +item.cantidad])]
        dataParseB = dataParseB.sort((a, b) => +b[1] - +a[1])

        this.setState({
          chartList: {
            ...this.state.chartList,
            H: res.data.data.values.length > 0 ? this.createChart2('ColumnChartH',
              {
                legend: false,
                exporting: {enabled: false},
                // chart: { type: 'bar' },
                title: {
                    text: `Número de decomisos de <i>${this.state.currentDataEspecie.pli_txt_scientificname}</i> por pais en los últimos 10 años`
                },
                xAxis: { title: { text: 'Países' }, categories: [...dataParseB.map(item => item[0])] },
                yAxis: {
                    min: 0,
                    title: {
                        text: 'Cantidad'
                    }
                },
                // legend: { reversed: true },
                series: [{type: 'column', 
                dataSorting: {
                  // enabled: true,
                  // sortKey: 'custom.value'
                },
                name: 'Cantidad', data: [...dataParseB.map(itemS => +itemS[1])]}]
              },
            ) : null

            
          }
        })
      })
    }
    createChart (type, data, options, size = false) {
     
        
        return  <Chart
        
        height={size.height !== undefined ? size.height : '22em'}
        chartType={ type }
        loader={<div className="ld ld-spinner  ld-spin"></div>}
        data={data}
        
        options={ options }
        // For tests
        rootProps={{ 'data-testid': Date.now() }}
        mapsApiKey={ 'AIzaSyD-9tSrke72PouQMnMX-a7eZSW0jkFMBWY' }
      />
      

   


    }
    createChart2 (id = '', options = {}, size = false) {
      // console.log('checkObjects', checkObjects(options, 'xAxis.title'))
        
        return  <CHighcharts id={ id } options={
          {
            ...options,
            chart: {
              ...checkObjects(options, 'chart'),
              style: {
                fontFamily: "\"Poppins\", \"Lato\", \"sans-serif\"",
                fontSize: '0.9em',
                ...checkObjects(options, 'chart.style')
              },
            },
            colors: ['#09ad23', '#f39511', '#c3081d', '#f5dd35', '#ce16ea',
              '#ae191b', '#990099', '#e40000', '#7c0000', '#a8368d'],
            exporting: {enabled: false},
            credits: {
              enabled: false
            },
            title: {
              style: { "color": "#000", "fontSize": "1.1em", fontWeight: 'bold' },
              ...options.title,
            },
            xAxis: {
              ...checkObjects(options, 'xAxis'),
              title: {
                ...checkObjects(options, 'xAxis.title'),
                style: {
                  color: 'black',
                  fontWeight: 'bold',
                  ...checkObjects(options, 'xAxis.title.style')
                },
                
              },
              labels: {  
                style: {
                  color: 'black',
                  fontWeight: 'bold'
                }
              },
              
            },
            yAxis: {
              ...checkObjects(options, 'yAxis'),
              title: {
                ...checkObjects(options, 'yAxis.title'),
                style: {
                  color: 'black',
                  fontWeight: 'bold',
                  ...checkObjects(options, 'yAxis.title.style')
                },
                
              },
              labels: {  
                style: {
                  color: 'black',
                  fontWeight: 'bold'
                }
              },
              
            },
            
          }
        } 
        callbackchart={ evt => {}}
        loader={ SpinLoaderStyle }
        />
      

   


    }
    createChartMaps3 (id = '', options = {}, series = [], callback = null, size = false) {
     
        
        return  <CMapHighcharts id={ id } 
        options={
          {
            ...options,
            chart: {
              ...checkObjects(options, 'chart'),
              style: {
                fontFamily: "\"Poppins\", \"Lato\", \"sans-serif\"",
                fontSize: '0.9em',
                ...checkObjects(options, 'chart.style')
              },
            },
            colors: ['#09ad23', '#f39511', '#c3081d', '#f5dd35', '#ce16ea',
              '#ae191b', '#990099', '#e40000', '#7c0000', '#a8368d'],
            exporting: {enabled: false},
            credits: {
              enabled: false
            },
            title: {
              ...options.title,
              style: { 
                "color": "#000", "fontSize": "1.1em", fontWeight: 'bold',
                ...checkObjects(options, 'title.style')
              },
            },
            xAxis: {
              ...checkObjects(options, 'xAxis'),
              title: {
                ...checkObjects(options, 'xAxis.title'),
                style: {
                  color: 'black',
                  fontWeight: 'bold',
                  ...checkObjects(options, 'xAxis.title.style')
                },
                
              },
              labels: {  
                style: {
                  color: 'black',
                  fontWeight: 'bold'
                }
              },
              
            },
            yAxis: {
              ...checkObjects(options, 'yAxis'),
              title: {
                ...checkObjects(options, 'yAxis.title'),
                style: {
                  color: 'black',
                  fontWeight: 'bold',
                  ...checkObjects(options, 'yAxis.title.style')
                },
                
              },
              labels: {  
                style: {
                  color: 'black',
                  fontWeight: 'bold'
                }
              },
              
            },
          }
        } 
        series={
          series
        }
        callbackchart={callback}
        loader={ SpinLoaderStyle }
        />
      

   


    }
    expeciesMasExportadasTab3 = () => {
      let parse = []
      // if (this.state.especiesMasExportadasTab3.length < 10) {
      //   this.state.especiesMasExportadasTab3.concat(new Array(10 - this.state.especiesMasExportadasTab3.length))
      // }
      parse = []
      let k = 0
      for(let i = 0; i < 2 ; i++) {
        parse.push(new Array(5))
        // parse[i] = 
        for(let j = 0; j < 5 ; j++) {
          parse[i][j] = false
          if (this.state.especiesMasExportadasTab3[k] !== undefined) {
            parse[i][j] = this.state.especiesMasExportadasTab3[k]
            k++
          } 
        }  
      }
      
      return  (<div>
        { parse.map((itemR, index) => {

          return itemR !== undefined ? <div key={ index } className="columns">
                 { itemR.map((item, index2) => {
            return item ? (
              <div key={ index2 } className="column">
              <div className="card">
                <header className="card-header" style={{backgroundColor:  item.color}}>
                  <div className="card-header-title">
                    <a style={{color: 'white'}} onClick={ e => {
                      e.preventDefault()
                      
                      let dataDestino = [['Pais', 'Cantidad'], ...item.destino.map(refCa => {
                        return [refCa.exp_txt_importer, +refCa.cantidad]
                      })]
                      if (this.chartMapGlobal) {
                        let currentSerie = this.chartMapGlobal.get(item.exp_txt_taxon);
                        
                        // currentSerie.setVisible(!currentSerie.visible);


                        var series      = currentSerie.chart.series;
                        if (currentSerie.visible && currentSerie.chart.restIsHidden) {
                            
                            series.forEach(function(item, index){
                                if (!['Basemap', 'Pais'].includes(item.name))
                                  item.setVisible(true, false);
                            });
                            currentSerie.chart.restIsHidden = false;
                          } else {
                            
                            series.forEach(function(item, index){
                              if (!['Basemap', 'Pais'].includes(item.name))
                                item.setVisible(false, false);
                            });
                            currentSerie.show()
                            currentSerie.chart.restIsHidden = true;
                          }

                      }

                      this.setState({
                        // currentEspecieTab3: item.exp_txt_taxon,
                      //   mapsChartPais: this.createChart('GeoChart',
                      //   dataDestino,
                      //   {
                      //     backgroundColor: this.BGMapChart
                      //   }, {height: '30em'}
                      // )
                      })
                    } } href="">
                      { item.exp_txt_taxon }
                    </a>
                  </div>
                </header>
                <div className="card-content pt-1 pb-1">
                  <div className="content">
                    <p className="mb-1"><b>Total operaciones: </b>{ item.cantidad }</p>
                    <p className="mb-1"><b>País destino: </b></p>
                    { item.destino[0] !== undefined ? <p className="mb-1">{ item.destino[0].pais } : { +item.destino[0].cantidad }</p> : null }
                    { item.destino[1] !== undefined ? <p className="mb-1">{ item.destino[1].pais } : { +item.destino[1].cantidad }</p> : null }
                    { item.destino[2] !== undefined ? <p className="mb-1">{ item.destino[2].pais } : { +item.destino[2].cantidad }</p> : null }
                  </div>
                </div>
            
              </div>
              </div>
            ) : null
          })}
          </div> : null
        })
      
        }
    </div>)
    }
    componentWillUnmount() {
      
      if (this.requestInit) this.requestInit.cancel()
    }
    cargarchartyear(datos){
        // let year = [
        //     ['Años', 'Cantidad']       
        // ]
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.yearchart)

        datos.yearimp.map(year =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Año')
                datos.paisimp.map(pais=>{
                    filaDatachart.push(pais.pais)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(year.exp_int_year) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.paisimp.map(pais=>{
                
                row = arrayData.find(data => data[1].pais == pais.pais && data[1].exp_int_year == year.exp_int_year) //CONDICION
                
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })

            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })

          this.setState({
            yearChart: DataChart,
            dataLoadingStatus: 'ready'
        })
        
        // this.initTypeahead()
        // this.initDatatable()
    }
    cargarchartpresentacionyear(datos){
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.termimp)

        datos.yearimp.map(year =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Año')
                datos.allterm.map(term=>{
                    filaDatachart.push(term.termino)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(year.exp_int_year) //PRIMER ELEMENTO DEL ROW
            
            datos.allterm.map(term => {
                row = arrayData.find(data => data[1].termino == term.termino && data[1].exp_int_year == year.exp_int_year) //CONDICION
                //console.log(data)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        
          this.setState({
            termChart: DataChart,
        })

    }
    cargarchartespeciepais(datos){
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.espepais)

        datos.alltaxon.map(taxon =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Especie')
                datos.paisimp.map(pais=>{
                    filaDatachart.push(pais.pais)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(taxon.exp_txt_taxon) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.paisimp.map(pais=>{
                
                row = arrayData.find(data => data[1].pais == pais.pais && data[1].especie == taxon.exp_txt_taxon) //CONDICION
                //console.log(arrayData)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            taxonChart: DataChart,
        })
    }
    cargarchartimporter(datos){
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.presenpais)

        datos.allpresen.map(term =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Presentacion')
                datos.paisimp.map(pais=>{
                    filaDatachart.push(pais.pais)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(term.exp_txt_term) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.paisimp.map(pais=>{
                
                row = arrayData.find(data => data[1].pais == pais.pais && data[1].termino == term.exp_txt_term) //CONDICION
                //console.log(arrayData)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            presenChart: DataChart,
        })
    }
    cargarchartespecieyear(datos){
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.taxonyear)
        let nombrepais = datos.isocodepais[0].pais
        //console.log(nombrepais)
        
        datos.alltaxon.map(taxon =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Especie')
                datos.yearimp.map(year=>{
                    filaDatachart.push(year.exp_int_year)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(taxon.exp_txt_taxon) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.yearimp.map(year=>{
                
                row = arrayData.find(data => data[1].exp_int_year == year.exp_int_year && data[1].especie == taxon.exp_txt_taxon) //CONDICION
                //console.log(arrayData)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            taxonyearChart: DataChart,
            nombrepais: nombrepais
        })
    }
    cargarcharttermyear(datos){
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.termyear)
        
        datos.allpresen.map(term =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Especie')
                datos.yearimp.map(year=>{
                    filaDatachart.push(year.exp_int_year)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(term.exp_txt_term) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.yearimp.map(year=>{
                
                row = arrayData.find(data => data[1].exp_int_year === year.exp_int_year && data[1].exp_txt_term === term.exp_txt_term) //CONDICION
                //console.log(arrayData)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            termyearChart: DataChart,
        })
    }
    cargarchartpaiscantidad(datos){
        let paiscant = [
            ['Pais', 'Cantidad']       
        ]
        datos.paiscantidadchart.map((item,index) => {
        //console.log(datos.yearchart)
        paiscant.push([item.pais,parseInt(item.cantidad)])
          });
          this.setState({
            paiscantidadchart: paiscant
        })
    }
    cargarcharttermpais(datos){
        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true

        let arrayData = Object.entries(datos.presenpais)

        datos.allpresen.map(term =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push('Presentacion')
                datos.paisimp.map(pais=>{
                    filaDatachart.push(pais.pais)
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            //CONTENIDO
            filaDatachart.push(term.exp_txt_term) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            datos.paisimp.map(pais=>{
                
                row = arrayData.find(data => data[1].pais == pais.pais && data[1].termino == term.exp_txt_term) //CONDICION
                //console.log(arrayData)
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION
                    filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                else
                    filaDatachart.push(0)
            })
            //console.log(DataChart)
            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })
        
        //console.log(DataChart)
          this.setState({
            presenChart: DataChart,
        })
    }
    cargarchartyearcantidad(datos){
        let yearcant = [
            ['Año', 'Cantidad']       
        ]
        datos.yearcantidadchart.map((item,index) => {
        //console.log(datos.yearchart)
        yearcant.push([item.pais,parseInt(item.cantidad)])
          });
          this.setState({
            yearcantidadchart: yearcant
        })
    }
    
    cargarcharttaxoncantidad(datos){
        let yearcant = [
            ['Especie', 'Cantidad']       
        ]
        datos.especiecantidadchart.map((item,index) => {
        //console.log(datos.yearchart)
        yearcant.push([item.pais,parseInt(item.cantidad)])
          });
          this.setState({
            yearcantidadchart: yearcant
        })
    }
    cargarchartespecantidad(datos){
        let especant = [
            ['Especie', 'Cantidad']       
        ]
        datos.especantidadchart.map((item,index) => {
        //console.log(datos.yearchart)
        especant.push([item.exp_txt_taxon,parseInt(item.cantidad)])
          });
          this.setState({
            especantidadchart: especant
        })
    }
    cargarcharttermcantidad(datos){
        let tecant = [
            ['Presentacion', 'Cantidad']       
        ]
        datos.termcantidadchart.map((item,index) => {
        //console.log(datos.yearchart)
        tecant.push([item.exp_txt_term,parseInt(item.cantidad)])
          });
          this.setState({
            tecantidadchart: tecant
        })
    }
 
    //Cargar chart barras multiples
    cargarchartbarrasmultiples(datos, data_x_column, axis_y_column, x, name_x, y, y_first_name, name_y, charName, confObjChar){
        // let year = [
        //     ['Años', 'Cantidad']       
        // ]


        let DataChart = []
        let filaDatachart = []
        let row
        let isFirstRow = true
        let total_data = 0

        let arrayData = Object.entries(datos)

        console.log(arrayData)

        console.log(x)
        console.log(y)

        y.map(y_el =>{

            //CABECERA
            if(isFirstRow){
                filaDatachart.push(y_first_name)
                x.map(x_el=>{
                    filaDatachart.push(x_el[name_x])
                })
                DataChart.push(filaDatachart)
                filaDatachart = []
            }

            

            //CONTENIDO
            filaDatachart.push(y_el[name_y]) //PRIMER ELEMENTO DEL ROW
            //console.log(data[1].pais)
            x.map(x_el=>{
                let i = x_el[name_x]
                let j = y_el[name_y]

                //console.log(j)
                //console.log(i)

                row = arrayData.find(data => data[1][data_x_column] == i && data[1][axis_y_column] == j) //CONDICION
                
                if(row) //SI EXISTE EL ELEMENTO CON ESA CONDICION´
                    {   
                        total_data = total_data + 1
                        filaDatachart.push(parseInt(row[1].cantidad)) //AGREGA EL ATRIBUTO SOLICITADO
                    } 
                else
                    filaDatachart.push(0)
            })

            DataChart.push(filaDatachart)
            filaDatachart = []
            isFirstRow = false
        })

       
        this.setState({
            [charName]: this.renderChart(DataChart, total_data, confObjChar),
            dataLoadingStatus: 'ready'
        })
       
    }
    //Chart barras simple
    cargarChartBarrasSimple(datos, x_first, x_col, y_first, y_col, chartName, confObjChar){
        let totalData = 0
        let dataChart = [
            [x_first, y_first]       
        ]

        datos.map((item,index) => {
        //console.log(datos.yearchart)
        totalData = totalData + 1
        dataChart.push([item[x_col],parseInt(item[y_col])])
          });
          this.setState({
            [chartName]: this.renderChart(dataChart, totalData, confObjChar)
        })
    }
    _fnGenerateEspecies = (id, pli_int_id) => {
      this.setState({
        loadInformationTab1: false,
        initTabOne: true,
        chartList: {
          aperture: false,
          showGenerar: false,
          A: SpinLoaderStyle,
          B: SpinLoaderStyle,
          BB: SpinLoaderStyle,
          C: SpinLoaderStyle,
          D: SpinLoaderStyle,
          DD: SpinLoaderStyle,
          E: SpinLoaderStyle,
          F: SpinLoaderStyle,
          G: SpinLoaderStyle,
          H: SpinLoaderStyle,
        },
      })

      axios.get(baseUrl('cites/dashboard/info'), {
        params: {especie: id, id: pli_int_id},
        cancelToken: this.requestInit.token
      }).then(res => {
        
        // let dEspecie = this.state.especiesSelect.find(item => item.pli_int_id === especie)
        
        this.setState({
          loadInformationTab1: true,
          currentDataEspecie: res.data.data.especie,
          
          currentDataEspeciePaises: res.data.data.paises
        })
        this.generateChartsTab1({
          baseUrl: baseUrl(`cites/dashboard/charts`),
        })
      })
    }
    onClick_btnGenerar = () => {
      let especie = this.refSelectEspecies.current.value
      if (+especie <= 0 ) {
        return false
      }
      
      // console.log('onClick_btnGenerar', dEspecie)
      let dEspecie = this.state.especiesSelect.find(item => item.pli_int_id === especie)
      this._fnGenerateEspecies(especie, dEspecie.pli_int_id)
    }
    onClick_btnGenerarTypeaHead = () => {
      // let especie = this.refSelectEspecies.current.value
      if (+this.state.typeahead.pli_int_id <= 0 ) {
        return false
      }
      
      // console.log('onClick_btnGenerar', dEspecie)
      // let dEspecie = this.state.especiesSelect.find(item => item.pli_int_id === especie)
      this._fnGenerateEspecies(this.state.typeahead.pli_int_id, this.state.typeahead.pli_int_id)
    }
    //Fin chart barras simple

    //RenderizarChart
    renderChart(data, total_data, objConf)
    {
        if(total_data > 0){

            let CharTitle = objConf.CharTitle
            let hAxisTitle = objConf.hAxisTitle
            let vAxisTitle = objConf.vAxisTitle
            let id = objConf.id
            
            return (
            
            <Chart
            width={'1350px'}
            height={'400px'}
            chartType="BarChart"
            loader={<div>Loading Chart</div>}
            
            data={data}
            options={
                {
                    legend: {position: 'bottom', textStyle: {fontSize: 11},maxLines:3},
                    title: CharTitle,
                    chartArea: { width: '50%' },
                    isStacked: true,
                    hAxis: {
                    title: hAxisTitle,
                    minValue: 0,
                    },
                    vAxis: {
                    title: vAxisTitle,
                    }}
            }
            // For tests
            rootProps={{ 'data-testid': id }}
            />)
        }
        else{
            return (
                <div className="is-3"> <h3> No se encontraron exportaciones para este gráfico</h3></div>
            )
        }

       

    }


    //traer reportes
    changeTab = (evt, a) => {
      evt.preventDefault()
      console.log('click', evt, a)
      
    }
 

    render() {
        return this.state.dataLoadingStatus === 'ready' ?(
            <div id="vc-dashboard-cites">
                <div className="tabs ctabs is-centered is-boxed">
                    <ul>
                       
                        <li className={ this.state.currentTab === 1 ? 'is-active' : '' }>
                        <a onClick={ e => this.setState({currentTab: 1}) } data-target="tab1">
                            <span className="icon is-small"><i className="fas fa-paw" aria-hidden="true"></i></span>
                            <span>{this.props.language('por_especie','Por especie')}</span>
                        </a>
                        </li>
                        <li className={ this.state.currentTab === 2 ? 'is-active' : '' }>
                        <a onClick={ e => this.setState({currentTab: 2}) } data-target="tab2">
                            <span className="icon is-small"><i className="fas fa-list-ol" aria-hidden="true"></i></span>
                            <span>{this.props.language('por_año','Por año')}</span>
                        </a>
                        </li>
                        <li className={ this.state.currentTab === 3 ? 'is-active' : '' }>
                        <a onClick={ e => this.setState({currentTab: 3}) } data-target="tab3">
                            <span className="icon is-small"><i className="fas fa-flag" aria-hidden="true"></i></span>
                            <span>{this.props.language('por_pais','Por país')}</span>
                        </a>
                        </li>
                        <li>
                        </li>
                    </ul>
                    </div>
                <section className="section is-main-section">
            
                <div id="tab1" className={(this.state.currentTab === 1 ? ' is-active' : 'is-hidden')}>
                  <div className={"card card-tab "}>
                    <header className=" card-header">
                    <div className="card-header-title">
                      { this.props.language('filtro','Filtro') }
                    </div>

                    </header>
                    <div className="card-content">

                      <form action="" onSubmit={ e=> e.preventDefault()} autoComplete="off">
                        <div className="columns is-vbottom">
                          <div className="column is-5">
                            <div className="field">
                              <label htmlFor="search_especies" className="label">{this.props.language('gen_busca_nom_cie_o_com','Buscar por nombre científico o nombre común')}</label>
                              <div className="control is-expanded">
                                <input id="search_especies" autoComplete="off" className="input" type="text" placeholder={this.props.language('gen_ingre_nom_cie_o_com','Ingrese el nombre científico o común')}></input>
                              </div>
                            </div>
                          </div>
                          <div className="column is-2">
                            <div className="control">
                              <div className="buttons">
                                <button id="btnGenerar" disabled={ !this.state.chartList.showGenerar } onClick={
                                  this.onClick_btnGenerarTypeaHead } className="button is-primary">
                                  <div>
                                    <div style={ !this.state.chartList.showGenerar ? hiddenBtnGenerar : {} }>{this.props.language('generar')}
                                    </div>
                                    { this.state.chartList.showGenerar ? null : SpinLoader}
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>
                          </div>
                          <hr></hr>
                          <div className="columns is-vbottom">
                          <div className="column is-2">
                            <div className="field"><label htmlFor="sel_cites" className="label">{this.props.language('apendice','Apéndice')}</label>
                              <div className="control is-expanded"><span className="select is-empty is-fullwidth">
                                  <select ref={ this.refSelectCites } onChange={ this.onChange_cites } id="sel_cites"
                                    disabled={ this.state.citesSelect.length===0}>
                                    {/* <option value="-1">-- Seleccione--</option> */}
                                    {this.state.citesSelect}
                                  </select>
                                </span></div>
                            </div>
                          </div>
                          <div className="column is-2">
                            <div className="field"><label htmlFor="sel_reyno" className="label">{this.props.language('reino','Reino')}</label>
                              <div className="control is-expanded"><span className="select is-empty is-fullwidth">
                                  <select ref={ this.refSelectReyno } onChange={ e=> {

                                    this.setState({
                                    filtersTabOne: {
                                    grupo: '-1',
                                    reyno: e.target.value
                                    }
                                    })
                                    // if (e.target.value === '-1') {
                                    this.refSelectGrupos.current.value = '-1'
                                    this.refSelectEspecies.current.value = '-1'
                                    // }
                                    }} id="sel_reyno" disabled={ this.state.especiesSelect.length===0}>
                                    <option value="-1">-- {this.props.language('sel_todos')}--</option>
                                    {this.COptionsReyno()}
                                  </select></span></div>
                            </div>
                          </div>
                          <div className="column is-3">
                            <div className="field"><label htmlFor="sel_grupos" className="label">{this.props.language("dash_cites_grupo")}</label>
                              <div className="control is-expanded"><span className="select is-empty is-fullwidth">
                                  <select ref={ this.refSelectGrupos } onChange={ e=> {
                                    // this.currentSelect.especie = '0'
                                    this.setState({
                                    filtersTabOne: {
                                    ...this.state.filtersTabOne,
                                    grupo: e.target.value
                                    }
                                    })
                                    // if (e.target.value === '-1') {
                                    this.refSelectEspecies.current.value = '-1'
                                    // }
                                    }} id="sel_grupos" disabled={ this.state.especiesSelect.length===0}>
                                    <option value="-1">-- {this.props.language('sel_todos')}--</option>
                                    {this.COptionsGrupos()}
                                  </select>
                                </span></div>
                            </div>
                          </div>
                          <div className="column is-3">
                            <div className="field"><label htmlFor="sel_especies" className="label">{this.props.language('especies','Especies')}</label>
                              <div className="control is-expanded"><span className="select is-empty is-fullwidth">
                                  <select defaultValue="-1" ref={ this.refSelectEspecies } onChange={
                                    this.onChange_especie } id="sel_especies" disabled={
                                    this.state.especiesSelect.length===0}>
                                    <option value="-1">--{this.props.language('seleccionar','Seleccionar')}--</option>
                                    { this.COptionsEspecies() }
                                  </select>
                                </span></div>
                            </div>
                          </div>
                          <div className="column is-2">
                            <div className="control">
                              <div className="buttons">
                                <button id="btnGenerar" disabled={ !this.state.chartList.showGenerar } onClick={
                                  this.onClick_btnGenerar } className="button is-primary">
                                  <div>
                                    <div style={ !this.state.chartList.showGenerar ? hiddenBtnGenerar : {} }>{this.props.language('generar','Generar')}
                                    </div>
                                    { this.state.chartList.showGenerar ? null : SpinLoader}
                                  </div>
                                </button>
                              </div>
                            </div>
                          </div>

                        </div>


                      </form>


                    </div>
                  </div>
                      { this.state.chartList.showGenerar ? null: SpinLoaderStyle }
                      { this.state.chartList.aperture && this.state.loadInformationTab1 ? <Card id="dbc-card-description">
                      {/* { false ? <Card> */}
                        <Card.Header>
                          <Card.Header.Title>
                            <span className="icon"><i className="mdi mdi-finance"></i></span>
                            <span>{ this.props.language('ser_desc_especie', 'Descripción de la especie') } <i>{ this.state.currentDataEspecie.pli_txt_scientificname }</i></span>&nbsp;&nbsp;<a href={  baseUrlWP(`biodiversidad/reportes/especies/dashboard/?especie=${this.state.currentDataEspecie.pli_int_id}`) } target="_blank" rel="noreferrer"><span className="tag is-primary"><span>{ this.props.language('ver_ficha', 'Ver ficha') }</span></span></a>
                          </Card.Header.Title>
                         <a onClick={ e => this.setState({ 
                            panels: {...this.state.panels, description : !this.state.panels.description }}) 
                          } className="card-header-icon" aria-label="more options">
                          <span className="icon">
                            <i className={ 'fas fa-angle-' + (this.state.panels.description ? 'down' : 'left')} aria-hidden="true"></i>
                          </span>
                          </a>
                        </Card.Header>
                        <Card.Content className={ this.state.panels.description ? '' : 'is-hidden' }>
                        <div className={ 'columns ' + (this.state.initTabOne ? '' : 'is-hidden') }>
                           
                         
                          <div className="column">
                            <div className="animation animated fadeInUp" data-animation="fadeInUp" data-animation-delay="0.02s" >
                                  <ul>
                                      <li>
                                          <h5 className="title is-italic">{ this.state.currentDataEspecie.pli_txt_scientificname }</h5>
                                      </li>
                                  </ul>
                                  
                                  <div className="heading_s1 mb-2"> 
                                      <h5>{this.props.language('ser_infoconservacion','Información de conservación')}</h5>
                                  </div>
                                  <ul className="profile_info list_none">                                     
                                      <li>
                                          <span className="title">UICN:</span>
                                          <p> {this.state.currentDataEspecie.pli_txt_uicn}</p>
                                      </li>
                                      <li>
                                          <span className="title">CITES:</span>
                                          <p>{this.state.currentDataEspecie.pli_txt_cite_f}</p>
                                      </li>
                                  </ul>
                                  {/* <hr className="mb-1 mt-1"/> */}
                                  <div className="heading_s1 mb-2"> 
                                      <h5>{this.props.language('ser_infotaxonomica', 'Información taxonómica')}</h5>
                                  </div>
                                  <ul className="profile_info list_none">
                                      
                                      <li>
                                          <span className="title">{this.props.language('nombre_comun','Nombre común')}:</span>
                                          <p> {this.state.currentDataEspecie.pli_txt_commonnames_f}</p>
                                      </li>
                                      
                                      <li>
                                          <span className="title">{this.props.language('reino','Reino')}:</span>
                                          <p>{this.state.currentDataEspecie.pli_txt_kingdom}</p>
                                      </li>
                                      <li>
                                          <span className="title">{this.props.language('filo','Filo')}:</span>
                                          <p>{this.state.currentDataEspecie.pli_txt_phylum}</p>
                                      </li>
                                      <li>
                                          <span className="title">{this.props.language('clase','Clase')}:</span>
                                          <p>{this.state.currentDataEspecie.pli_txt_class}</p>
                                      </li>
                                      <li>
                                          <span className="title">{this.props.language('orden','Orden')}:</span>
                                          <p>{this.state.currentDataEspecie.pli_txt_order}</p>
                                      </li>
                                      <li>
                                          <span className="title">{this.props.language('familia','Familia')}:</span>
                                          <p>{this.state.currentDataEspecie.pli_txt_family}</p>
                                      </li>
                                      <li>
                                          <span className="title">Genus:</span>
                                          <p>{this.state.currentDataEspecie.pli_txt_genus}</p>
                                      </li>
                                  </ul>
                                  
                              </div>
                          </div>
                          <div className="column">
                          
                          <div className="animation animated fadeInUp" data-animation="fadeInUp" data-animation-delay="0.02s" >
                          { this.state.mapsChartDistribution }
                            </div>
                        </div>
                          { 
                                  this.state.loadInformationTab1 ? 
                                 <ImageDistribution  alt={ this.state.currentDataEspecie.pli_txt_scientificname }
                                 src={ `${this.state.currentDataEspecie.imagedefault}` }
                                 />
                                  : SpinLoader
                                }
                         
                        </div>
                      
                         
                        </Card.Content>
                      </Card> : null }

                      { !(
                        this.state.chartList.A || 
                        this.state.chartList.B || 
                        this.state.chartList.BB || 
                        this.state.chartList.C ||
                        this.state.chartList.D ||
                        this.state.chartList.DD ||
                        this.state.chartList.E ||
                        this.state.chartList.F ||
                        this.state.chartList.G ||
                        this.state.chartList.H 
                        ) ? <Card>
                            <Card.Content>
                              <div className="columns">

                              <div className="column is-full has-text-centered">
                        
                                <h1><b>{ this.props.language('sin_datos','Sin Datos') }</b></h1>
                              </div>
                           
                              </div>
                            </Card.Content>
                        </Card> : null }
                      { this.state.chartList.aperture && (this.state.chartList.A || this.state.chartList.B || this.state.chartList.BB || this.state.chartList.C) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('exportaciones','Exportaciones')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/exportaciones?q1=' + this.state.currentDataEspecie.pli_txt_scientificname) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, exportaciones : !this.state.panels.exportaciones }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.exportaciones ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.exportaciones ? '' : 'is-hidden' }>
                              <div className="columns">

                                <div className="column is-full">
                                  <div className="columns">

                                    { this.state.chartList.B !== null ? <div className={ 'column ' + (this.state.chartList.BB === null ? 'is-half  is-offset-one-quarter' : '')}>
                                      { this.state.chartList.B }
                                    </div> : null }
                                    { this.state.chartList.BB !== null ? <div className={ 'column ' + (this.state.chartList.B === null ? 'is-half  is-offset-one-quarter' : '')}>
                                      { this.state.chartList.BB }
                                    </div> : null }
                                  </div>
                                </div>
                              </div>
                              <div className="columns">
                                <div className="column is-full">
                                  <div className="columns">

                                    { this.state.chartList.A !== null ? <div className={ 'column ' + (this.state.chartList.C === null ? 'is-half  is-offset-one-quarter' : '')}>
                                      { this.state.chartList.A }
                                    </div> : null }
                                    { this.state.chartList.C !== null ? <div className={ 'column ' + (this.state.chartList.A === null ? 'is-half  is-offset-one-quarter' : '')}>
                                      { this.state.chartList.C }
                                    </div> : null }
                                  </div>
                                </div>
                              </div>
                            </Card.Content>
                        </Card> : null }
                        { this.state.chartList.aperture && (this.state.chartList.D || this.state.chartList.DD || this.state.chartList.E || this.state.chartList.F) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>Importaciones{this.props.language('')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/importaciones?q1=' + this.state.currentDataEspecie.pli_txt_scientificname) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, importaciones : !this.state.panels.importaciones }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.importaciones ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.importaciones ? '' : 'is-hidden' }>
                              <div className="columns">
                                <div className="column is-full">

                                  <div className="columns">
                                    { this.state.chartList.E !== null ? <div className={ 'column ' + (this.state.chartList.DD === null ? 'is-half  is-offset-one-quarter' : '')}>
                                      { this.state.chartList.E }
                                    </div> : null }
                                    { this.state.chartList.DD !== null ? <div className={ 'column ' + (this.state.chartList.E === null ? 'is-half  is-offset-one-quarter' : '')}>
                                      { this.state.chartList.DD }
                                    </div> : null }
                                  </div>
                                </div>
                              </div>
                              <div className="columns">
                                <div className="column is-full">

                                  <div className="columns">
                                    { this.state.chartList.D !== null ? <div className={ 'column ' + (this.state.chartList.filaDatachart === null ? 'is-half  is-offset-one-quarter' : '')}>
                                      { this.state.chartList.D }
                                    </div> : null }
                                    { this.state.chartList.F !== null ? <div className={ 'column ' + (this.state.chartList.D === null ? 'is-half  is-offset-one-quarter' : '')}>

                                      { this.state.chartList.F }
                                    </div> : null }
                                  </div>
                                </div>
                              </div>
                            </Card.Content>
                        </Card> : null }
                           { this.state.chartList.aperture && (this.state.chartList.G) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('permisos','Permisos')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/permiso?q1=' + this.state.currentDataEspecie.pli_txt_scientificname) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, solo_permisos : !this.state.panels.solo_permisos }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.solo_permisos ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.solo_permisos ? '' : 'is-hidden' }>
                              <div className="columns ">
                                { this.state.chartList.G !== null ? <div className="column is-half  is-offset-one-quarter">
                                  { this.state.chartList.G }
                                </div> : null }
                              
                              </div>
                              </Card.Content>
                            </Card> : null }
                            { this.state.chartList.aperture && (this.state.chartList.H) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('decomisos','Decomisos')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/listadecomisos?q1=' + this.state.currentDataEspecie.pli_txt_scientificname) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, solo_decomisos : !this.state.panels.solo_decomisos }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.solo_decomisos ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.solo_decomisos ? '' : 'is-hidden' }>
                              <div className="columns ">
                                { this.state.chartList.H !== null ? <div className="column is-half  is-offset-one-quarter">
                                  { this.state.chartList.H }
                                </div> : null }
                              </div>
                              </Card.Content>
                            </Card> : null }
                    

                  </div>
                  
                <div id="tab2" className={(this.state.currentTab === 2 ? ' is-active' : 'is-hidden')}>
                  <div className={"card card-tab "}>

                    <header className="card-header">
                      <div className="card-header-title">
                        { this.props.language('filtro','Filtro') }
                      </div>

                    </header>
                    <div className="card-content">
                    <div className="columns is-vbottom">
                        <div className="column is-2">
                          <div className="field is-groupedx ">
                            <label className="label">{this.props.language('por_año','Por Año')}: </label>
                            <div className="control">
                              <div className="select">
                                <select defaultValue={false}
                                disabled={ +this.state.currentDataEspecie.pli_int_id <= 0 }
                                ref={ this.refSelectYear }
                                  id="sel_year" >
                                  {/* <option value="-1">-- Seleccione--</option> */}
                                  {/* {this.state.citesSelect} */}
                                  { this.getLastYearsOption() }
                                
                                </select>
                              </div>
                            </div>
                        

                          </div>

                        </div>
                        <div className="column">
                          
                        <div className="control">
                              <div className="buttons">
                                <button type="button"  
                                disabled={ +this.state.currentDataEspecie.pli_int_id <= 0 || !this.state.chartListYear.showGenerar }
                                onClick={ this.onClick_btnGenerarYear } className="button is-primary">
                                  <div>
                                      <div style={ !this.state.chartListYear.showGenerar ? hiddenBtnGenerar : {} }>{this.props.language('generar','Generar')}</div>
                                      { this.state.chartListYear.showGenerar ? null : SpinLoader}
                                    </div>
                                </button>
                              </div>
                            </div>
                        </div>
                      </div>
                    </div>
                    </div>
                        { this.state.chartListYear.showGenerar ? null: SpinLoaderStyle }
                        { this.state.chartListYear.aperture && (this.state.chartListYear.AA || this.state.chartListYear.A || this.state.chartListYear.B) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('resumen_exportaciones','Resumen exportaciones')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/exportaciones?q2=' + this.refSelectYear.current.value) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, yearexportaciones : !this.state.panels.yearexportaciones }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.yearexportaciones ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.yearexportaciones ? '' : 'is-hidden' }>
                              <div className="columns">
                                { this.state.chartListYear.AA !== null ? <div className="column is-4">
                                  { this.state.chartListYear.AA }
                                </div> : null }
                                { this.state.chartListYear.A !== null ? <div className="column is-4">

                                  { this.state.chartListYear.A }
                                </div> : null }
                                { this.state.chartListYear.B !== null ? <div className="column is-4">
                                  { this.state.chartListYear.B }
                                </div> : null }
                              </div>
                              </Card.Content>
                        </Card> : null }

                        { this.state.chartListYear.aperture && (this.state.chartListYear.IA || this.state.chartListYear.IB || this.state.chartListYear.IC) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('resumen_importaciones','Resumen importaciones')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/importaciones?q2=' + this.refSelectYear.current.value) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, yearimportaciones : !this.state.panels.yearimportaciones }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.yearimportaciones ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.yearimportaciones ? '' : 'is-hidden' }>
                              <div className="columns">
                                { this.state.chartListYear.IA !== null ? <div className="column is-4">
                                  { this.state.chartListYear.IA }
                                </div> : null }
                                { this.state.chartListYear.IB !== null ? <div className="column is-4">

                                  { this.state.chartListYear.IB }
                                </div> : null}
                                { this.state.chartListYear.IC !== null ? <div className="column is-4">
                                  { this.state.chartListYear.IC }
                                </div> : null }
                              </div>
                              </Card.Content>
                        </Card> : null}


                        { this.state.chartListYear.aperture && (this.state.chartListYear.YPA || this.state.chartListYear.YPB) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('resumen_permisos','Resumen permisos')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/permiso?q2=' + this.refSelectYear.current.value) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, yearpermisos : !this.state.panels.yearpermisos }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.yearpermisos ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.yearpermisos ? '' : 'is-hidden' }>
                              <div className="columns">
                                { this.state.chartListYear.YPA !== null ? <div className="column is-6">
                                   
                                  { this.state.chartListYear.YPA }
                                </div> : null}
                                { this.state.chartListYear.YPB ? <div className="column is-6">

                                  { this.state.chartListYear.YPB }
                                </div>: null }
                              </div>
                              </Card.Content>
                        </Card> : null }
                          { this.state.chartListYear.aperture && (this.state.chartListYear.YDA || this.state.chartListYear.YDB) ? <Card>
                            <Card.Header>
                              <Card.Header.Title>
                                <span className="icon"><i className="mdi mdi-finance"></i></span>
                                <span>{this.props.language('resumen_decomisos','Resumen decomisos')}</span>&nbsp;&nbsp;<Link target="_blank" to={ localUrl('/reportes/listadecomisos?q2=' + this.refSelectYear.current.value) }><span className="tag is-primary"><span>Ver detalles</span></span></Link>
                              </Card.Header.Title>
                             <a onClick={ e => this.setState({ 
                                panels: {...this.state.panels, yeardecomisos : !this.state.panels.yeardecomisos }}) 
                              } className="card-header-icon" aria-label="more options">
                              <span className="icon">
                                <i className={ 'fas fa-angle-' + (this.state.panels.yeardecomisos ? 'down' : 'left')} aria-hidden="true"></i>
                              </span>
                              </a>
                            </Card.Header>
                            <Card.Content className={ this.state.panels.yeardecomisos ? '' : 'is-hidden' }>
                              <div className="columns">
                                { this.state.chartListYear.YDA !== null ? <div className="column is-6">
                                   
                                  { this.state.chartListYear.YDA }
                                </div> : null}
                                { this.state.chartListYear.YDB ? <div className="column is-6">

                                  { this.state.chartListYear.YDB }
                                </div>: null }
                              </div>
                              </Card.Content>
                        </Card> : null }
                    </div>
                  
                <div id="tab3" className={(this.state.currentTab===3 ? ' is-active' : 'is-hidden' )}>
                    <div className={"card card-tab "}>
                    <header className="card-header">
                      <div className="card-header-title">
                        { this.props.language('filtro') }
                      </div>

                    </header>
                      <div className=" card-content">
                        <div className="columns is-vbottom">
                          <div className="column is-2">
                            <div className="field is-groupedx ">
                              <label className="label">{this.props.language('pais','Por País')} : </label>
                              <div className="control">
                                <div className="select">
                                  <select disabled={ !this.state.paises } ref={ this.refSelectPais } id="sel_pais">
                                    {/* <option value="-1">-- Seleccione--</option> */}
                                    { this.state.paises }

                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column is-2">
                            <div className="field is-groupedx ">
                              <label className="label">{this.props.language('año','Año')} : </label>
                              <div className="control">
                                <div className="select">
                                  <select disabled={ !this.state.paises } ref={ this.refSelectPaisYear }
                                    id="sel_years_pais">
                                    <option value="-1">-- {this.props.language('sel_todos', 'Todos')} --</option>
                                    { this.getLastYearsOption() }

                                  </select>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="column">
                              <div className="control">
                                <div className="buttons">
                                  <button type="button" disabled={ +this.state.currentDataEspecie.pli_int_id <=0 ||
                                    !this.state.chartListPais.showGenerar } onClick={ this.onClick_btnGenerarPais }
                                    className="button is-primary">
                                    <div>
                                      <div style={ !this.state.chartListPais.showGenerar ? hiddenBtnGenerar : {} }>{this.props.language('generar','Generar')}
                                      </div>
                                      { this.state.chartListPais.showGenerar ? null : SpinLoader}
                                    </div>
                                  </button>

                                </div>
                              </div>
                          

                          </div>
                        </div>
                        <div className="columns">
                          <div className="column">

                            { this.state.mapsChartPais && this.state.currentEspecieTab3 ? <div id="infoFloat">
                              <p>{ this.state.currentEspecieTab3 }</p>
                            </div> : null }
                            { this.state.mapsChartPais }

                          </div>
                        </div>
                        
                      </div>
                    </div>
                    <div className={"card card-tab " + (this.state.especiesMasExportadasTab3.length> 0 ? '' :
                          'is-hidden')}>
                      <header className="card-header">
                        <div className="card-header-title">
                          {this.props.language('expor_lista')}
                        </div>

                      </header>
                      <div className="card-content">
                        <div className={ 'columns ' + (this.state.especiesMasExportadasTab3.length> 0 ? '' :
                          'is-hidden')}>
                          <div className="column">
                            { this.expeciesMasExportadasTab3() }
                          </div>
                        </div>
                      </div>
                    </div>
                    { this.state.chartListPais.aperture && (this.state.chartListPais.A || this.state.chartListPais.B) ? <div className={"card card-tab "}>
                      <header className="card-header">
                        <div className="card-header-title">
                          {this.props.language('expor_resumen','Resumen')}
                        </div>

                      </header>
                      <div className="card-content">
                        
                        <div className={ 'columns '}>
                          { this.state.chartListPais.A !== null ? <div className="column">
                          { this.state.chartListPais.A  }
                          </div> : null }
                          { this.state.chartListPais.B !== null ? <div className="column">
                          { this.state.chartListPais.B  }
                          </div> : null }
                        </div>
                      </div>
                    </div> : null }
                  </div>
                </section>

            </div>
        ):(
            
                
            <div className="columns is-justify-content-center mb-6">
                <div className="field is-horizontal">
                    <div className="field-body">
                        <div  className="field pt-2">
                            <div ref={ this.spinnerLoad } className="ld ld-spinner  ld-spin">
                            </div>
                        </div>
                        <div  className="field">
                             <h2 className="tamano is-2"> {this.props.language('cargando','Cargando')}... </h2>
                        </div>
                    </div>
                    
                </div>
            
            
            
            </div>
  
        )
    }
}

export default connect(getLanguage, {set_datapage, SetLanguage})(DashboardCites)